/***************************  Menu Click -> Show/Hide ***************************/

$(document).ready(function () {
    $('.menu-drawer-close-btn').click(function () {
        $('body').removeClass('overflow-hidden-mobile menu-opening');
    
        var details = $('header-drawer details[open]');
        setTimeout(function () {
          $(details).removeAttr('open');
          $(details).removeClass('menu-opening');
          $(details).find('summary').attr('aria-expanded', 'false');
        }, 400);
    });
    
    // $('.header__icon--menu').click(function () {
    //     //  $('body').addClass('overflow-hidden-mobile menu-opening');
    //     //  var details = $('header-drawer details');
    //     //  $(details).attr('open', '');
    //     //  $(details).addClass('menu-opening');
    //     //  $(details).find('summary').attr('aria-expanded', 'true');
    // });
    
    $('#MainContent').click(function (event) {
        $('body').removeClass('overflow-hidden-mobile menu-opening');

        var details = $('header-drawer details[open]');
        setTimeout(function () {
            $(details).removeAttr('open');
            $(details).removeClass('menu-opening');
            $(details).find('summary').attr('aria-expanded', 'false');
        }, 400);
    });

    $(".grey-title-wrapper .menu-area").click(function () {
        $(this).closest('section').find('.page-width').slideToggle(400, "swing", null);
    });
})

/************************* Menu Click -> Show/Hide end  *************************/